export default __webpack_public_path__ + "static/media/navWhiteLogo.de9c0af6.svg";